import React, { useEffect, useState } from 'react';
import crossfilter from 'crossfilter2';
import styled from 'styled-components';
import { Button,Select,Tree,Typography,Card} from 'antd';
import ReactECharts from 'echarts-for-react';
import Dashboard from './dashboard';
import {useParentState} from 'utils';
import {keywords} from './keywords';
import Language from 'components/language';

const { Option } = Select;

const MyReactECharts = ({option,onEvents,...other}) => {        
    const [chart,setChart]=React.useState(null)
    const onChartReady=(chart)=>{      
      setChart(()=>chart)
    };   
    useEffect(() => {
      
      if(chart){
         for(const key in onEvents)chart.on(key, onEvents[key]);          
      } 
      return () => {
        if(chart){
          for(const key in onEvents)chart.off(key, onEvents[key]);            
        }
      
      };
    }, [chart,onEvents]);    
    return <ReactECharts option={option} onChartReady={onChartReady} {...other} />;
};


const getCrossfilter =({data,groups,columns})=>{  
 
  const cf = crossfilter(data);  
  const dgs = groups.map(({name,f})=>{
    const dimension = cf.dimension((d) => d[name]);
    const group = dimension.group().reduceSum(f);
    const uniques = group.all().map(o=>o.key);      
    return {name,dimension,group,uniques};
  });
   const tree = groups.map(({name,f},i)=>(
     {         
      title: columns[name],
      key: `${name}`,
      checkable:false,
      children: dgs[i].uniques.map((key,i)=>({title:key,key:`${name}-${key}`})),
    }
  ));
  
  return {cf,dgs,tree};
};

function transformArrayToObject(inputArray) {
  const result = {};

  inputArray.forEach(item => {
    const [key, value] = item.split('-');    
    if (!result[key])result[key] = [];      
    result[key].push(value.trim());
  });

  return result;
}

const Container = styled.div`
  // display:flex;
  // flex: 1;  
  // flex-wrap: wrap;
  // gap: 12px;
  // justify-content: center;
  width:100%;
  height:100%;
  
  .ant-card {
    height:100%;
    display: flex;
    flex-direction: column;
    
  }
  .ant-card-body {
    flex:1;
    padding: 12px;
  }
`
const Layout = styled.div`
  display:flex;

`
const SiderHeader = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between;
  
`
const Sider = styled.div`
  border: solid 1px #0000002e; 
  border-radius: 6px;
  min-width: 200px; 
  
  h5 {
    margin: 6px;
  }
`
const MyCard = styled(Card)`
  min-width:400px;  
`

const PieChart = ({ data,groups:_groups,lng,layouts,setLayouts }) => {    
  const columns = keywords.filter(o=>o.group=="dataColHeader").reduce((acc,o)=>({...acc,[o.key]:o[lng]}),{});
  
  const [selectedGroups, setSelectedGroups] = useState({});  
  
  const [echarts, setEcharts] = useState([]);      
  const [item,setItem] = useState();
  const {cf,dgs=[],tree} = item||{}    
  const [checkedKeys, setCheckedKeys] = useState([]);
  const groups=_groups(dgs,selectedGroups,lng);
 
 
  useEffect(() => {    
    setItem(getCrossfilter({data,groups,columns}));
  },[data]);
  

  useEffect(() => {        
    dgs.forEach(dg=>dg.dimension.filter(selectedGroups[dg.name]?(d)=>selectedGroups[dg.name].includes(d):null));    
    const newCharts = dgs.map(dg=>groups.find(g=>g.name==dg.name).options());
    setEcharts(newCharts);
  }, [item,selectedGroups]);
  
  const handleCheck=(checked)=>{
    const selectedGroups = transformArrayToObject(checked);
    setSelectedGroups(selectedGroups);
    setCheckedKeys(checked);
  };
  
  const onCheck = (o) => {
    const {checked} = o;
    handleCheck(checked);    
  };

  const handleChartClick = (params) => {            
    const {seriesName,data}=params;
    if (data) {      
      const {name} = data;
      const key =`${seriesName}-${name}`;      
      const checked=checkedKeys.includes(key)?checkedKeys.filter(o=>o!=key):[...checkedKeys,key];
      
      handleCheck(checked);                   
    }
  };
  
  const onEvents={ 
    click: handleChartClick
  }
  const onReset=()=>{
    handleCheck([]);
  }
  
  
  
  const gridItems = groups.map((o,i)=>({...o, body:()=> <MyReactECharts option={echarts[i]||{}} style={{ height: '100%',width: '100%'  }} onEvents={onEvents}  />}));
  
  return (
    <Layout>
     <Sider>
       <SiderHeader>
        <Typography.Title level={5}><Language id={"filters"}/></Typography.Title>
        {checkedKeys.length>0 &&<Button type="link" onClick={onReset}>reset</Button>}
       </SiderHeader>
       {tree&&<Tree
        checkable
        checkStrictly={true}
        defaultExpandAll={true}
        // onExpand={onExpand}
        // expandedKeys={[]}
        // autoExpandParent={true}
        onCheck={onCheck}
        checkedKeys={checkedKeys}
        // onSelect={onSelect}
        // selectedKeys={selectedKeys}
        treeData={tree}
      />
      }
    </Sider>
      
      <Container>
        <Dashboard items={gridItems} layouts={layouts} setLayouts={setLayouts}/>     
      </Container>
    </Layout>
  );
};

export default PieChart;


      // if(!group)return setSelectedGroups({...selectedGroups,[seriesName]:[name]});
      // const array = selectedGroups[seriesName];
      // selectedGroups[seriesName]=array.includes(name)?array.filter(o=>o!=name):[...array,name];
      
      // setSelectedGroups(selectedGroups);
      
      

    // <Select
    //     placeholder="Select a group"
    //     style={{ width: 200, marginBottom: 20 }}
    //     onChange={(value)=>handleGroupChange("group",value)}
    //     // mode="multiple"
    //   >
    //     <Option value={"all"}>All Groups</Option>
    //     {uniqueGroups.map((group) => (
    //       <Option key={group} value={group}>
    //         {group}
    //       </Option>
    //     ))}
    //   </Select>
    //   <Select
    //     placeholder="Select an other group"
    //     style={{ width: 200, marginBottom: 20 }}
    //     onChange={(value)=>handleGroupChange("otherGroup",value)}
    //   >
    //     <Option value={"all"}>All Other Groups</Option>
    //     {uniqueOtherGroups.map((otherGroup) => (
    //       <Option key={otherGroup} value={otherGroup}>
    //         {otherGroup}
    //       </Option>
    //     ))}
    //   </Select>